import React from "react";
import Subtitle from "../../components/Subtitle/Subtitle";
import Navbar from "../../components/Navbar/Navbar";
import PrivacyPolicy from "./Section/PrivacyPolicy";

import { privacySubtitleObject } from "./Data";

function PrivacyPage() {
  return (
    <>
      <Navbar />
      <Subtitle {...privacySubtitleObject} />
      <PrivacyPolicy />
    </>
  );
}

export default PrivacyPage;
